module.exports = __webpack_public_path__ + "static/media/1_pl.f8d1eca3.png";